import React from "react";
import { useEvent } from "../hooks/useEvent";

type ScrollIntoView = (element: HTMLElement, options?: ScrollIntoViewOptions) => void;

const Context = React.createContext<ScrollIntoView | null>(null);

/**
 * JSDom does not implement Element#scrollIntoView, so we have to mock
 */
const nullScrollIntoView = (): void => {};

export const useScrollIntoView = (): ScrollIntoView => {
  const context = React.useContext(Context);

  return useEvent((element, options) => {
    if (!element || !("scrollIntoView" in element)) {
      return nullScrollIntoView();
    }

    if (context === null) {
      return element?.scrollIntoView(options) ?? nullScrollIntoView();
    }

    return context(element, options);
  });
};

export const MockScrollIntoViewProvider: React.FC<{ callback?: ScrollIntoView }> = (props) => {
  const { children, callback } = props;

  return <Context.Provider value={callback ?? nullScrollIntoView}>{children}</Context.Provider>;
};
